export const TEXT_BUTTON_AI = 'text-button-ai';
export const AI_MODAL_FLOATING_MENU_POPOVER = 'ai-modal-floating-menu-popover';
export const AI_MODAL_ROOT = 'ai-modal-root';
export const AI_MODAL_PROMPT_INPUT = 'ai-modal-prompt-input';
export const AI_MODAL_CANCEL_BUTTON = 'ai-modal-cancel-button';
export const AI_MODAL_SUBMIT_BUTTON = 'ai-modal-submit-button';
export const AI_MODAL_PROMPT_LIST_ITEM = 'ai-modal-prompt-list-item';
export const AI_MODAL_LOADING_INDICATOR = 'ai-modal-loading-indicator';
export const AI_MODAL_RESULTS_CONTENT = 'ai-modal-results-content';
export const AI_MODAL_RESULTS_CONTENT_ITEM = 'ai-modal-results-content-item';
export const AI_MODAL_RESULTS_FIST_ACTION_BUTTON = 'ai-modal-results-first-action-button';
export const AI_MODAL_RESULTS_SECOND_ACTION_BUTTON = 'ai-modal-results-second-action-button';
export const AI_MODAL_RESULTS_ACTIONS_POPOVER = 'ai-modal-results-actions-popover';
export const AI_MODAL_RESULTS_ACTIONS_POPOVER_TRIGGER = 'ai-modal-results-actions-popover-trigger';
export const AI_MODAL_NO_SELECTION_CONTAINER = 'ai-modal-no-selection-container';
export const AI_MODAL_ERROR_CONTAINER = 'ai-modal-error-container';
export const AI_MODAL_ERROR_RETRY_BUTTON = 'ai-modal-error-retry-button';
export const AI_MODAL_ERROR_CANCEL_BUTTON = 'ai-modal-error-cancel-button';
export const AI_MODAL_DISCARD_MODAL = 'ai-modal-discard-modal';

export const AI_EXPORTS_ALT_TEXT_INPUT_AREA = 'ai-exports-image-alt-text-input-area';
export const AI_EXPORTS_ALT_TEXT_GENERATE_BUTTON = 'ai-exports-image-alt-text-generate-button';
export const AI_EXPORTS_CAPTION_TRIGGER_BUTTON = 'ai-exports-image-caption-trigger-button';

export const AI_FLOW_SELECTION_POPOVER = 'ai-flow-selection-popover';
export const AI_FLOW_ITEM_CONTENT = 'ai-flow-popover-item-content';
export const AI_FLOW_ITEM_IMAGE = 'ai-flow-popover-item-image';

export const AI_IMAGE_MODAL_ROOT = 'ai-image-modal-root';
export const AI_IMAGE_MODAL_PROMPT_INPUT = 'ai-image-modal-prompt-input';
export const AI_IMAGE_MODAL_CANCEL_BUTTON = 'ai-image--modal-cancel-button';
export const AI_IMAGE_MODAL_SUBMIT_BUTTON = 'ai-image--modal-submit-button';
export const AI_IMAGE_MODAL_ERROR_RETRY_BUTTON = 'ai-modal-error-retry-button';
export const AI_IMAGE_MODAL_ERROR_CANCEL_BUTTON = 'ai-modal-error-cancel-button';
export const AI_IMAGE_MODAL_FEED_ITEM = 'ai-image-modal-feed-item';
export const AI_IMAGE_MODAL_FEED_LOADER = 'ai-image-modal-image-loader';
export const AI_IMAGE_MODAL_ACTION_INSERT_ABOVE = 'ai-image-modal-action-insert-above';
export const AI_IMAGE_MODAL_ACTION_INSERT_BELOW = 'ai-image-modal-action-insert-below';
export const AI_IMAGE_MODAL_ACTION_INSERT = 'ai-image-modal-action-insert';
export const AI_IMAGE_MODAL_IMAGE_STYLE = 'ai-image-modal-image-style';
export const AI_IMAGE_MODAL_PROMPT_HELPER_POPOVER = 'ai-image-modal-prompt-helper-popover';
export const AI_IMAGE_MODAL_PROMPT_HELPER_POPOVER_CLOSE =
  'ai-image-modal-prompt-helper-popover-close';
